import Vue from 'vue';
import SkyVideo from './sky-video';

Vue.component('sky-video', SkyVideo);

export default SkyVideo;



// WEBPACK FOOTER //
// ./scripts/sky-video/index.js